import AlarmAPI from '../AlarmAPI';
import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { useMemo } from 'react';
import { useAppSelector } from '../../store.model';
import { ALARMS_POLLING_INTERVAL } from '../Alarm.model';
import { getFeatureToggle } from '../../../shared/featureToggle';

type Options = Parameters<UseQuerySubscription<any>>[1];

function useAlarmsByWorkspace(
  workspaceId: string | undefined,
  options: Options = {}
) {
  const featureToggle = useAppSelector(getFeatureToggle);
  const { data: alarmsData, ...restAlarmAPI } =
    AlarmAPI.useGetMyIncidentByWorkspaceIdQuery(
      {
        workspaceId: workspaceId || '',
      },
      {
        skip: !workspaceId,
        pollingInterval: ALARMS_POLLING_INTERVAL,
        ...options,
      }
    );

  const data = useMemo(
    () =>
      alarmsData?.filter(
        (alarm) =>
          !featureToggle.HideDisconnectionAlarms ||
          (featureToggle.HideDisconnectionAlarms && alarm?.event !== '_disconn')
      ),
    [alarmsData, featureToggle.HideDisconnectionAlarms]
  );

  return {
    ...restAlarmAPI,
    data,
  };
}

export default useAlarmsByWorkspace;
